/**
 * @Author      Karen Yunuen Pozos Arias
 * @JobTitle    Full Stack
 * @Email       kpozos@ibl.mx
 *
 * Sorts menu options ascending by the label the user reads, so the order follows the active language.
 *
 * @param {Array<Object>} items - Menu options.
 * @param {Function} getLabel - Returns the visible (already translated) label of an option.
 * @returns {Array<Object>} New array sorted ascending, ignoring case and accents.
 */
export const sortMenuByLabel = (items = [], getLabel = (item) => item?.label) =>
    [...items].sort((a, b) => String(getLabel(a) ?? '').localeCompare(String(getLabel(b) ?? ''), undefined, { sensitivity: 'base' }));
